import { strategyVariantSavedCohortSchema, type StrategyVariantSavedCohort } from '@einhaus/project314-types';

/** One strategy per line: strategyId: jobId, startJobId-endJobId. Expansion is bounded before allocation. */
export function parseSavedCohortInput(text: string): StrategyVariantSavedCohort[] | undefined {
    if (!text.trim()) return undefined;
    const lines = text
        .trim()
        .split(/\n/)
        .filter((line) => line.trim());
    if (lines.length > 20) throw new Error('Select at most 20 strategies.');
    const cohorts = lines.map((line) => {
        const match = /^\s*(\d+)\s*:\s*(.+)\s*$/.exec(line);
        if (!match) throw new Error('Use one line per strategy: strategy ID: job IDs or ranges.');
        const jobIds: number[] = [];
        for (const token of match[2]!.split(',')) {
            const range = /^\s*(\d+)\s*(?:-\s*(\d+))?\s*$/.exec(token);
            if (!range) throw new Error('Job IDs must be positive integers or ascending ranges, separated by commas.');
            const start = Number(range[1]);
            const end = Number(range[2] ?? range[1]);
            if (
                !Number.isSafeInteger(start) ||
                !Number.isSafeInteger(end) ||
                start < 1 ||
                end < start ||
                end - start + jobIds.length >= 5000
            ) {
                throw new Error('Use positive IDs and at most 5,000 jobs per strategy.');
            }
            for (let id = start; id <= end; id++) jobIds.push(id);
        }
        if (new Set(jobIds).size !== jobIds.length) throw new Error('A job may appear only once per strategy.');
        return strategyVariantSavedCohortSchema.parse({ strategyId: Number(match[1]), jobIds });
    });
    if (new Set(cohorts.map((cohort) => cohort.strategyId)).size !== cohorts.length) throw new Error('Use one line per strategy.');
    if (cohorts.reduce((sum, cohort) => sum + cohort.jobIds.length, 0) > 20000) throw new Error('Select at most 20,000 jobs in total.');
    return cohorts;
}
